import { render } from "./EverEWaste.vue?vue&type=template&id=5f615fef"
import script from "./EverEWaste.vue?vue&type=script&lang=js"
export * from "./EverEWaste.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__